import {
  Card,
  CardBody,
  CardHeader,
  LoadingDots,
  Grid,
  Row,
  Col,
  TextInput,
  CardFooter,
  Button,
} from '@met/react-components';
import { Label } from '@met/react-components/dist/components/ToggleSwitch/styled';
import { updateLocale } from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../components/PageHeader';
import { translationsActions } from '../../store';

const Translation = props => {
  const dispatch = useDispatch();
  const { projectName, namespaceName, translationKey } = props.match.params;
  const data = useSelector(state => state.translations.data);

  const [isLoading, setIsLoading] = useState(true);
  const [translationData, setTranslationData] = useState({ translations: [] });

  useEffect(() => {
    dispatch(
      translationsActions.getTranslationsByNames(
        projectName,
        namespaceName,
        translationKey
      )
    ).finally(() => {
      setIsLoading(false);
    });
  }, [projectName, namespaceName, translationKey]);

  useEffect(() => {
    setTranslationData(data);
  }, [data]);

  const setTranslation = (languageId, value) => {
    setTranslationData(prev => {
      return {
        ...prev,
        translations: prev.translations.map(item => {
          if (item.languageId === languageId) {
            return {
              ...item,
              translationValue: value,
            };
          }
          return item;
        }),
      };
    });
  };

  const saveTranslations = () => {
    console.log(translationData);
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <LoadingDots />
      ) : data?.translationKeyId ? (
        <React.Fragment>
          <PageHeader
            title={
              <Link to={`/projects/${data.projectId}`}>
                {data.projectName} - {data.namespaceName}
              </Link>
            }
            subtitle='Translations'
          />
          <Card>
            <CardHeader>Project/Translation Info</CardHeader>
            <CardBody>
              <Grid fluid>
                <Row>
                  <Col>
                    <Label>Project:</Label>
                    <span>{data.projectName}</span>
                  </Col>
                  <Col>
                    <Label>Namespace:</Label>
                    <span>{data.namespaceName}</span>
                  </Col>
                  <Col>
                    <Label>Key:</Label>
                    <span>{data.translationKey}</span>
                  </Col>
                </Row>
              </Grid>
            </CardBody>
          </Card>
          <Card>
            <CardHeader>Translations</CardHeader>
            <CardBody>
              <Grid fluid>
                <Row>
                  <Col>Language</Col>
                  <Col>Translation</Col>
                </Row>
                {data.translations.map(item => {
                  return (
                    <Row key={item.languageId}>
                      <Col>{item.languageDescription}</Col>
                      <Col>
                        <TextInput
                          value={item.translationValue || ''}
                          onChange={e => {
                            setTranslation(item.languageId, e.target.value);
                          }}
                        />
                      </Col>
                    </Row>
                  );
                })}
              </Grid>
            </CardBody>
            <CardFooter>
              <Button primary onClick={saveTranslations}>
                Save
              </Button>
            </CardFooter>
          </Card>
        </React.Fragment>
      ) : (
        'Not Found'
      )}
    </React.Fragment>
  );
};

export default Translation;
